import { SolarAccountEs } from "@edp-models/ES/es-solar-account.model";
import { Action } from "@ngrx/store";

export enum ESolarAccountEsActions {
    GetSolarAccountEs = "[SolarAccount] Get SolarAccount",
    SetSolarAccountEs = "[SolarAccount] Set SolarAccount",
    GetAccountAPIError = "[SolarAccount] Get SolarAccount API Error",
    SetAccountAPIError = "[SolarAccount] Set SolarAccount API Error",
}

export class GetSolarAccountEs implements Action {
    public readonly type = ESolarAccountEsActions.GetSolarAccountEs;
}

export class GetAccountAPIError implements Action {
    public readonly type = ESolarAccountEsActions.GetAccountAPIError;
    constructor(public error: Error) {}
}

export class SetSolarAccountEs implements Action {
    public readonly type = ESolarAccountEsActions.SetSolarAccountEs;
    constructor(public payload: SolarAccountEs) {}
}

export class SetAccountAPIError implements Action {
    public readonly type = ESolarAccountEsActions.SetAccountAPIError;
    constructor(public payload: any) {}
}

export type SolarAccountEsActions =
    | GetSolarAccountEs
    | GetAccountAPIError
    | SetAccountAPIError
    | SetSolarAccountEs;
